import { reviewList } from "@/mocks/portal";

export default function ReviewSection() {
  return (
    <section id="review" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-accent-700 ring-1 ring-background-200">
              <i className="ri-history-line" />
              往期回顾
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              月度热度复盘
            </h2>
            <p className="mt-2 text-sm text-foreground-600">错过的热点不落伍，用专题回顾重新补课。</p>
          </div>
          <a
            href="/about"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            了解我们 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {reviewList.map((r) => (
            <a
              key={r.id}
              href="/about"
              className="group flex overflow-hidden rounded-xl border border-background-200 bg-background-100 transition-all hover:shadow-sm"
            >
              <div className="relative w-2/5 shrink-0 overflow-hidden">
                <img
                  src={r.image}
                  alt={r.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col justify-center p-5">
                <span className="flex items-center gap-2 text-xs font-semibold text-accent-700">
                  <i className="ri-calendar-line" />
                  {r.date} 复盘
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] font-normal text-foreground-600">
                    {r.count} 篇
                  </span>
                </span>
                <h3 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 line-clamp-2">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{r.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  阅读复盘 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}